import { Card, Text } from '../../../shared/styles/components/primitives.styles';
import { mixins, rgba, typography } from '../../../shared/styles/core/utils';

import styled from '../../../shared/types/transient-styled.types';
import { theme } from '../../../shared/styles/core/theme';
import { tokens } from '../../../shared/styles/core/tokens';

export const ScopeAlertContent = styled.div`
   display: flex;
   align-items: center;
   gap: ${tokens.space.xs};
   width: 100%;
   overflow: hidden;
`;

export const ScopeAlertText = styled(Text)`
   ${mixins.truncate}
   flex: 1;
   min-width: 0;
`;

export const ScopeLabel = styled.strong`
   white-space: nowrap;
`;

export const InfoCard = styled(Card)`
   margin-bottom: ${tokens.space.xl};
`;

export const ScopeCard = styled(Card)`
   margin-bottom: ${tokens.space.lg};
`;

export const DetailsCard = styled(Card)`
   margin-top: ${tokens.space.md};
`;

export const InfoGrid = styled.div`
   display: grid;
   grid-template-columns: 1fr 1fr 1fr;
   gap: ${tokens.space.md};
`;

export const SpanTwoColumns = styled.div`
   grid-column: span 2;
`;

export const ScopeSection = styled.div`
   margin-bottom: ${tokens.space.xxl};
`;

export const InputSection = styled.div`
   margin-bottom: ${tokens.space.xxl};
`;

export const MappingHeader = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
   padding: ${tokens.space.md} ${tokens.space.lg};
   background-color: ${theme.colors.bg.secondary};
   border-bottom: ${tokens.border.thin} ${theme.colors.border.default};
`;

export const MappingBody = styled.div`
   padding: ${tokens.space.lg};
`;

export const MappingType = styled.div`
   ${typography.bodyS}
   text-transform: uppercase;
   color: ${theme.colors.border.focus};
   font-weight: ${tokens.font.weight.semibold};
`;

export const DetailRow = styled.div<{ $highlight?: boolean }>`
   display: flex;
   justify-content: space-between;
   margin-bottom: ${tokens.space.sm};
   ${typography.bodyM}

   &:last-child {
      margin-bottom: 0;
   }
`;

export const DetailLabel = styled.span<{ $highlight?: boolean }>`
   color: ${({ $highlight }) => ($highlight ? theme.colors.state.error : theme.colors.text.secondary)};
   font-weight: ${({ $highlight }) => ($highlight ? tokens.font.weight.semibold : tokens.font.weight.normal)};
`;

export const DetailValue = styled.strong<{ $highlight?: boolean }>`
   color: ${({ $highlight }) => ($highlight ? theme.colors.state.error : theme.colors.text.primary)};
   font-weight: ${tokens.font.weight.semibold};
`;

export const ItemsList = styled.div`
   display: grid;
   grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
   gap: ${tokens.space.xs};
   margin-top: ${tokens.space.sm};
   max-height: 200px;
   overflow-y: auto;
`;

export const ItemChip = styled.span<{ $type?: 'affected' | 'excluded' }>`
   display: inline-flex;
   align-items: center;
   justify-content: center;
   padding: ${tokens.space.xs};
   ${typography.bodyS}
   background-color: ${({ $type }) => ($type === 'excluded' ? rgba(theme.colors.state.warning, 0.1) : rgba(theme.colors.state.info, 0.1))};
   border: ${tokens.border.thin} ${({ $type }) => ($type === 'excluded' ? theme.colors.state.warning : theme.colors.border.focus)};
   border-radius: ${tokens.radius.sm};
   font-weight: ${tokens.font.weight.medium};
   color: ${theme.colors.text.primary};
   font-family: monospace;
   white-space: nowrap;
   transition: ${tokens.transition.fast};

   &:hover {
      transform: translateY(-2px);
      box-shadow: ${tokens.shadow.sm};
   }
`;

export const DetailsSectionTitle = styled.h4`
   ${typography.bodyM}
   font-weight: ${tokens.font.weight.semibold};
   color: ${theme.colors.text.primary};
   margin-bottom: ${tokens.space.sm};
   display: flex;
   align-items: center;
   gap: ${tokens.space.xs};
`;

export const ClearAllButton = styled.button`
   margin-left: auto;
   ${typography.bodyS}
   background: none;
   border: none;
   color: ${theme.colors.text.tertiary};
   cursor: pointer;
   text-decoration: underline;
   padding: 0;

   &:hover {
      color: ${theme.colors.text.secondary};
   }
`;
